export const IGetCachedImageUseCaseType = Symbol('IGetCachedImageUseCase');
